const cpaMixins = {
	data() {
		return {
			initCpaTimer: null,
			sendTimeMS: 600,
			initTimeMS: 700, // 500 이였을때 호출 간헐적으로 안됨. 시간 더 길게
		};
	},
	methods: {
		loadCpa() {
			this.cpaNstationLoad();
			this.cpaTenpingLoad();
			this.cpaNswitchLoad();
		},
		initCpa() {
			if (this.initCpaTimer) clearTimeout(this.initCpaTimer);
			this.initCpaTimer = setTimeout(() => {
				this.cpaNstationInit();
				this.cpaNswitchInit();
			}, this.initTimeMS);
		},
		cpaNstationLoad() {
			let dc = document.getElementsByTagName('head')[0];
			let sc = document.createElement('script');
			sc.defer = true;
			sc.src = 'https://cdnet.nasmob.com/nstation/js/track/cpa_1.0.min.js';
			dc.appendChild(sc);

			console.log('nstation load');
		},

		cpaTenpingLoad() {
			let dc = document.getElementsByTagName('head')[0];
			let sc = document.createElement('script');
			sc.defer = true;
			sc.src = '//tenping.kr/scripts/cpa/tenping.cpa.V2_Domain.min.js';
			dc.appendChild(sc);

			//console.log('tenping str');
		},

		cpaNswitchLoad() {
			let dc = document.getElementsByTagName('head')[0];
			let sc = document.createElement('script');
			sc.defer = true;
			sc.src = 'https://scr.nsmartad.com/nswitch/npr_track/npr_track.js';
			dc.appendChild(sc);

			console.log('nswitch load');
		},
		cpaNstationInit() {
			// eslint-disable-next-line
			NSTATION.SCRIPT.init();

			console.log('nstation init');
		},
		cpaNswitchInit() {
			// eslint-disable-next-line
			new NSW_init_pr_param();

			console.log('nswitch init');
		},
	},
};

export default cpaMixins;
